module.exports = __webpack_public_path__ + "static/media/roundedBoxes_icon.a33c9f42.png";